import React from 'react';

import ImgLogoColor from './img/logo-poli-color.png';
import ImgLogo2 from './img/panel_redes_sociales.png';

import './css/styles.css';
import '../icon_fonts/fonts/style.css';

class PanelRedesSociales extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            urlInstagram: '',
            urlTwitter: '',
            urlYoutube: '',
        }
    }

    componentWillMount(){

        fetch('/api/uip/instagram/url', {
            method: 'GET',
            heders: {
                'Content-Type': 'application/json' 
            }
        })
            .then(response => response.json())
            .then(response => { this.setState({ urlInstagram:  response[0].url})})
            .catch(response => console.log(response))
        
        fetch('/api/uip/twitter/url', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json' 
            }
        })
            .then(response => response.json())
            .then(response => this.setState({ urlTwitter:  response[0].url}))
            .catch(response => console.log(response))

        fetch('/api/uip/youtube/url', {
            method: 'GET',
            heders: {
                'Content-Type': 'application/json' 
            }
        })
            .then(response => response.json())
            .then(response => this.setState({ urlYoutube:  response[0].url}))
            .catch(response => console.log(response))
    }

    render(){
        return(
            <div>
                <div className="position_logo_blue">
                    <img className="size_logo_blue" src={ImgLogo2}/>
                </div>
                <div className="container_redes_sociales">
                    <div className="sn_icons_left">
                        <a>
                            <span className="icon-instagram-with-circle sn_custom_icons"></span>
                        </a>
                        <a>
                            <span className="icon-twitter-with-circle sn_custom_icons"></span>
                        </a>
                        <a>
                            <span className="icon-youtube-with-circle sn_custom_icons"></span>
                        </a>
                    </div>
                    <div><img className="sn_logo_brand" src={ImgLogoColor} /></div>
                    <div className="sn_icons_right">
                        <a href={this.state.urlInstagram} target="_blank">
                            <span className="icon-instagram-with-circle sn_custom_icons hvr-pop"></span>
                        </a>
                        <a href={this.state.urlTwitter} target="_blank">
                            <span className="icon-twitter-with-circle sn_custom_icons hvr-pop"></span>
                        </a>
                        <a href={this.state.urlYoutube} target="_blank">
                            <span className="icon-youtube-with-circle sn_custom_icons hvr-pop"></span>
                        </a>
                    </div>
                </div>
            </div>
           
        );
    }
}

export default PanelRedesSociales;
